module.exports = __webpack_public_path__ + "img/crossword.f4d8c2c0.svg";